<template>
  <div v-if="showDialog" class="phone-binding-overlay" @click="handleOverlayClick">
    <div class="phone-binding-dialog" @click.stop>
      <div class="dialog-header">
        <h3>Vincular Número de Telefone</h3>
        <button class="close-btn" @click="closeDialog">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </button>
      </div>
      
      <div class="dialog-content">
        <div class="icon-wrapper">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" stroke="#50EF7C" stroke-width="2" fill="none"/>
          </svg>
        </div>
        
        <p class="message">
          Para acessar esta funcionalidade, você precisa vincular seu número de telefone e se tornar um usuário registrado.
        </p>
        
        <div class="benefits">
          <h4>Benefícios da conta registrada:</h4>
          <ul>
            <li>✓ Acesso completo a depósitos e saques</li>
            <li>✓ Histórico de transações</li>
            <li>✓ Bônus exclusivos</li>
            <li>✓ Suporte prioritário</li>
          </ul>
        </div>
      </div>
      
      <div class="dialog-actions">
        <button class="btn-secondary" @click="closeDialog">
          Continuar como convidado
        </button>
        <button class="btn-primary" @click="goToBinding">
          Vincular telefone
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()
const showDialog = ref(false)
const targetRoute = ref('')

const handlePhoneBindingEvent = (event: CustomEvent) => {
  showDialog.value = true
  targetRoute.value = event.detail?.targetRoute || ''
}

const closeDialog = () => {
  showDialog.value = false
  targetRoute.value = ''
  // 判断是否在首页，不在首页才跳转到首页
  if (router.currentRoute.value.path.includes('/m/home')) {
    router.push('/m/home')
  }
}

const handleOverlayClick = () => {
  closeDialog()
}

// 跳转到绑定页面
const goToBinding = () => {
  console.log('phone-binding')
  // 跳转到手机号绑定页面
  router.push('/m/phone-binding')
  showDialog.value = false
}

onMounted(() => {
  window.addEventListener('show-phone-binding', handlePhoneBindingEvent as EventListener)
})

onUnmounted(() => {
  window.removeEventListener('show-phone-binding', handlePhoneBindingEvent as EventListener)
})
</script>

<style scoped>
.phone-binding-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 0;
}

.phone-binding-dialog {
  background: #3D3D3D;
  border-radius: 12px;
  max-width: 480px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
}

.dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 12px ;
  border-bottom: 1px solid #4D4D4D;
  margin-bottom: 12px;
}

.dialog-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 00;
  color: #e1e1e1;
}

.close-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0px;
  color: #999;
  border-radius: 6px;
  transition: all 0.2s;
  padding-top: 4px;
}

.close-btn:hover {
  color: #e1e1e1;
}

.dialog-content {
  padding: 0 12px;
  text-align: center;
}

.icon-wrapper {
  margin-bottom: 12px;
}

.message {
  font-size: 16px;
  color: #d4d4d4;
  line-height: 1.6;
  margin-bottom: 12px;
}

.benefits {
  text-align: left;
  background: #444444;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 12px;
}

.benefits h4 {
  margin: 0 0 12px 0;
  font-size: 14px;
  font-weight: 600;
  color: #d4d4d4;
}

.benefits ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

.benefits li {
  padding: 4px 0;
  font-size: 14px;
  color: #999999;
}

.dialog-actions {
  display: flex;
  gap: 12px;
  padding: 0 12px 12px;
}

.btn-secondary,
.btn-primary {
  flex: 1;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
}

.btn-secondary {
  background: #555555;
  color: #999999;
}

.btn-secondary:hover {

}

.btn-primary {
  background: url('../assets/images/btn-bg-phpon.png') no-repeat;
  background-size: 100% 100%;
  color: #333333;
}
/* 移动端适配 */
@media (max-width: 768px) {
  .phone-binding-overlay {
    padding: 12px;
  }
  
  .phone-binding-dialog {
    max-width: 88%;
  }
  
  .dialog-header {
    padding: 6px 12px 0;
  }
  
  .dialog-header h3 {
    font-size: 16px;
  }
  
  .dialog-content {
    padding: 0 12px;
  }
  
  .dialog-actions {
    padding: 0 12px 12px;
    flex-direction: column;
  }
  
  .btn-secondary,
  .btn-primary {
    flex: none;
  }
}
</style>
